import Sign from './Sign';

export default Sign;
